/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Mutation } from '@apollo/client/react/components';
import Form from '../components/form';
import { EDIT_PRODUCT_TYPE } from '../../../../queries/products/productType';

export const Update = (props) => {
  return (
    <Mutation
      mutation={EDIT_PRODUCT_TYPE}
      update={async () => {
        await props.refetch();
      }}
    >
      {updateProductTypes => (
        <Form query_f={updateProductTypes} {...props} />
      )}
    </Mutation>

  );
};
